import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './components/app';
import reportWebVitals from './reportWebVitals';
import './assets/css/styles.css';
import {productData} from './assets/data/products';
import {testimonialData} from './assets/data/testimonials';

declare global {
  interface Window {
      gtag: (type: string, title: string, data?: object) => void;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App 
        productData={productData}
        testimonialData={testimonialData}
      />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
